<div class="drop-number-selector"
     [class.dark-theme]="isDarkTheme"
     [class.light-theme]="!isDarkTheme">

    <!-- Label with optional edit toggle -->
    @if (label) {
        <div class="selector-header">
            <div class="selector-label">{{ label }}</div>
            @if (showManualInput && !noManualEdit) {
                <button mat-icon-button (click)="toggleManualInput()">
                    <mat-icon>{{showInput ? 'visibility_off' : 'edit'}}</mat-icon>
                </button>
            }
        </div>
    }

    <!-- Manual input field -->
    @if (showInput && showManualInput) {
        <div class="manual-input">
            <input type="number"
                   class="manual-input-field"
                   [value]="value"
                   (input)="onInputChange($event)"
                   (blur)="onInputBlur($event)"
                   (keydown.enter)="onInputEnter($event)"
                   [min]="min"
                   [max]="max"
                   [placeholder]="placeholder || value.toString()">
        </div>
    }

    <!-- Canva-style number input with +/- buttons and dropdown -->
    <div class="canva-number-input" [class.dropdown-open]="showDropdown">
        <button class="canva-btn canva-btn-minus"
                (click)="decrement()"
                [disabled]="disabled || value <= min"
                type="button">
            <mat-icon>remove</mat-icon>
        </button>

        <button class="canva-input-wrapper"
                type="button"
                [disabled]="disabled"
                (click)="openDropdown()">
            <span class="canva-input-text">{{value}}</span>
            <mat-icon class="dropdown-arrow">expand_more</mat-icon>
        </button>

        <button class="canva-btn canva-btn-plus"
                (click)="increment()"
                [disabled]="disabled || value >= max"
                type="button">
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <!-- Dropdown with preset values -->
    @if (showDropdown) {
        <div class="canva-dropdown" [class.open-upward]="dropdownOpenUpward">
            <div class="preset-list">
                @for (preset of presetValues; track preset) {
                    <div class="preset-option"
                         [class.selected]="preset === value"
                         (click)="selectPresetValue(preset)">
                        {{ preset }}
                    </div>
                }
            </div>
        </div>
    }

    <!-- Backdrop to close dropdown -->
    @if (showDropdown) {
        <div class="dropdown-backdrop" (click)="closeDropdown()"></div>
    }

    <!-- Validation errors (for reactive forms integration) -->
    @if (validations && validations.length > 0 && formControl) {
        <div class="validation-errors">
            @for (validation of validations; track validation) {
                @if (formControl.hasError(validation.name) && (formControl.dirty || formControl.touched)) {
                    <div class="error-message">{{ validation.message }}</div>
                }
            }
        </div>
    }
</div>